import { IMenuPage } from "common/form/fields/PagesField";
import InputType from "common/form/InputType";
import { Form, Input } from "decorator-form";

@Form({title: "Link View Config"})
export default class PageLinkViewConfig {

	@Input({type: InputType.PAGE, title: "Page"})
	public page: IMenuPage;


	@Input({type: InputType.PAGE_PATH, title: "Page Path"})
	public pagePath: string[];

}



// WEBPACK FOOTER //
// ./src/common/views/pageLink/PageLinkViewConfig.ts